<template>
  <div>
    <AnnouncementEditorPage v-if="$route.path == '/console/announcement/edit'"/>
    <MailTemplateListPage v-if="$route.path == '/console/mail/templateList'"/>
    <QQGroupListPage v-if="$route.path == '/console/misc/qqgroups'"/>
    <CloudArchivePage v-if="$route.path == '/console/cloudArchive/recover'"/>
    <BlackListPage v-if="$route.path == '/console/misc/blacklist'"/>
    <GreyListPage v-if="$route.path == '/console/misc/greylist'"/>
    <WhiteListPage v-if="$route.path == '/console/misc/whitelist'"/>
    <ClientLogQueryPage v-if="$route.path == '/console/misc/clientlog'"/>
    <SensitiveWordListPage v-if="$route.path == '/console/misc/sensitivewords'"/>
    <PictureListPage v-if="$route.path == '/console/picture'"/>
    <FunctionSwitchListPage v-if="$route.path == '/console/function-switch/list'"/>
    <ZoneListPage v-if="$route.path == '/console/zone/list'"/>
  </div>
</template>

<script>
import AnnouncementEditorPage from "@/pages/announcement/AnnouncementEditorPage";
import MailTemplateListPage from "@/pages/mail/MailTemplateListPage";
import QQGroupListPage from "@/pages/qqGroup/QQGroupListPage";
import CloudArchivePage from "@/pages/cloudArchiv/uploadAndDownload";
import BlackListPage from "@/pages/blackList/BlackListPage";
import GreyListPage from "@/pages/greyList/GreyListPage";
import WhiteListPage from "@/pages/whiteList/WhiteListPage";
import SensitiveWordListPage from "@/pages/sensitiveWord/SensitiveWordListPage";
import PictureListPage from "@/pages/picture/PictureListPage";
import ClientLogQueryPage from "@/pages/clientLog/ClientLogQueryPage";
import FunctionSwitchListPage from "@/pages/function-switch/FunctionSwitchListPage";
import ZoneListPage from "@/pages/zone/ZoneListPage";

export default {
  data() {
    return {

    }
  },

  components: {
    AnnouncementEditorPage,
    MailTemplateListPage,
    QQGroupListPage,
    CloudArchivePage,
    BlackListPage,
    GreyListPage,
    WhiteListPage,
    SensitiveWordListPage,
    PictureListPage,
    ClientLogQueryPage,
    FunctionSwitchListPage,
    ZoneListPage,
  },

  methods: {
  }
};
</script>